var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCautionicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19738_64296)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0002 57.0001C17.0002 34.9088 34.9088 17.0002 57.0001 17.0002C79.0914 17.0002 97 34.9088 97 57.0001C97 79.0914 79.0914 97 57.0001 97C34.9088 97 17.0002 79.0914 17.0002 57.0001ZM56.9988 81.9947C54.2373 81.9947 51.9988 79.7562 51.9988 76.9947L51.9988 56.9952C51.9988 54.2337 54.2373 51.9952 56.9988 51.9952C59.7602 51.9952 61.9988 54.2337 61.9988 56.9952L61.9988 76.9947C61.9988 79.7562 59.7602 81.9947 56.9988 81.9947ZM51.4989 36.9936C51.4989 40.0312 53.9613 42.4936 56.9989 42.4936C60.0365 42.4936 62.4989 40.0312 62.4989 36.9936L62.4989 36.327C62.4989 33.2894 60.0365 30.827 56.9989 30.827C53.9613 30.827 51.4989 33.2894 51.4989 36.327L51.4989 36.9936Z",
    fill: "#1AAA55"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 97,
    height: 97,
    rx: 48.5,
    stroke: "#1AAA55",
    strokeOpacity: 0.28,
    strokeWidth: 17
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19738_64296"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionicon);
export default __webpack_public_path__ + "static/media/cautionicon.0eb327274fed469c0e6e4fb099a195e3.svg";
export { ForwardRef as ReactComponent };